import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { isApp } from '@/utils/app'
import { getEntryInfo } from '@/utils'
import { useRoute, useRouter } from 'vue-router'
import wx from 'weixin-js-sdk'


export default /*#__PURE__*/_defineComponent({
  __name: 'pay-success',
  setup(__props) {

// 平安支付成功中转页
const $route = useRoute()
const $router = useRouter()
const eqSn = $route.query.eqSn as string
const activeKey = $route.query.activeKey as string
const client = $route.query.client as string
const entryData = getEntryInfo()
const isFromActive = entryData.type === 'active'
const isMiniProgram = $route.query.mini === 'member'
if (isMiniProgram) {
} else if (isApp) {
  // 如果不是外部浏览器打开的，理论上可以直接跳转到详情页
  if (isFromActive) {
    // 此时需要跳转到激活中转页
    $router.replace({
      name: 'insurance-jijia-pay-check',
      query: {
        eqSn,
        activeKey,
        client,
      },
    })
  } else {
    $router.replace({
      name: 'insurance-jijia-insurance-detail',
      query: {
        eq_sn: eqSn,
        from: 'payed',
      },
    })
  }
} else {
  // 一般是小程序去往浏览器支付的场景
  $router.replace({
    name: 'insurance-jijia-mini-pay-success',
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})